import Card, { CardIcon, CardBody, CardTitle, CardDescription } from '../../components/Card';
import data from './data';
import './services.css';

const Services = () => {
  return (
    <section className="services section section--muted" id="services">
      <div className="container">
        {/* Section Header */}
        <div className="services__header" data-aos="fade-up">
          <h2 className="services__title">Proses Service Kami</h2>
          <p className="services__subtitle">
          Kami menghadirkan proses servis yang terstruktur untuk memastikan setiap perangkat Apple anda mendapatkan penanganan yang aman, transparan, dan berkualitas di setiap tahap pengerjaan.
          </p>
        </div>

        {/* Services Grid */}
        <div className="services__grid" data-aos="fade-up" data-aos-delay="200">
          {data.map((service, index) => (
            <Card 
              key={service.id} 
              variant="service"
              interactive={false}
              className="services__card"
              data-aos="fade-up"
              data-aos-delay={300 + (index * 100)}
            >
              <CardIcon 
                variant="primary" 
                className="services__icon"
              >
                {service.icon}
              </CardIcon>
              
              <CardBody className="services__content">
                <CardTitle className="services__card-title">
                  {service.title}
                </CardTitle>
                
                <CardDescription className="services__card-description">
                  {service.desc}
                </CardDescription>
                
                {/* Step Number */}
                <div className="services__step-number">
                  <span className="services__step-text">Langkah</span>
                  <span className="services__step-digit">{String(index + 1).padStart(2, '0')}</span>
                </div>
              </CardBody>
            </Card>
          ))}
        </div>

        {false && (
  <div className="services__cta" data-aos="fade-up" data-aos-delay="600">
    <h3 className="services__cta-title">Siap Memperbaiki Perangkat Apple Anda?</h3>
    <p className="services__cta-description">
      Nikmati layanan servis Apple yang cepat, profesional, dan terpercaya dengan penanganan terbaik dari teknisi berpengalaman kami.
    </p>

    <button 
      className="btn btn-primary services__cta-button"
      onClick={() => {
        const contactSection = document.getElementById('contact');
        if (contactSection) {
          contactSection.scrollIntoView({ behavior: 'smooth' });
        }
      }}
      aria-label="Hubungi kami untuk layanan"
    >
      Konsultasi Gratis
    </button>
  </div>
)}
      </div>
    </section>
  );
};

export default Services;
